import { render, staticRenderFns } from "./ElProductDescription.vue?vue&type=template&id=0ee6f293"
import script from "./ElProductDescription.vue?vue&type=script&lang=js"
export * from "./ElProductDescription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports